export default __webpack_public_path__ + "static/media/AgraLovelace.52b303aa.png";